// Update your existing cashHeader.js file (./cashierHeader/cashHeader.js)

import { React, useState, useEffect } from 'react';
import Profile from '../../../assets/images/profileImg.png';
import './header.css';
import { Navigate, useLocation, useNavigate, useNavigation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout, saveLogin, setUserRole } from '../../../../Redux/actions';
import { ReactComponent as Notification } from '../../../assets/images/svgIcons/ic_bell.svg';
import { ReactComponent as PayIn } from '../../../assets/images/svgIcons/payIn.svg';
import { ReactComponent as Calculator } from '../../../assets/images/svgIcons/calculator.svg';
import { ReactComponent as Payout } from '../../../assets/images/svgIcons/payout.svg';
import { ReactComponent as Dollar } from '../../../assets/images/svgIcons/dollar.svg';
import { ReactComponent as Chat } from '../../../assets/images/svgIcons/ic_chat.svg';
import { ReactComponent as Setting } from '../../../assets/images/svgIcons/ic_setting.svg';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getUserName } from '../../../../Redux/selecters';
import { clearCart } from '../../../../Redux/actions/cartAction';
import { clearComboCart } from '../../../../Redux/actions/comboAction';
import { clearTable } from '../../../../Redux/actions/tableAction';
import { FiLogOut, FiSunrise, FiLock, FiUnlock } from 'react-icons/fi';
import { toggleTheme } from '../../../../Redux/reducers/themeReducer';
import userManagement from '../../../services/userManagement';
import ApiService from '../../../services/apiService';
import { invokeLogin } from '../../../services/signalRService';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useScreenLock } from '../ScreenLock/ScreenLockContext'; // Import the screen lock context

const CashierHeader = () => {
  const [headerText, setHeaderText] = useState('Dashboard');
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userName = useSelector(getUserName);
  const theme = useSelector((state) => state.theme.mode);
  const { isLocked, lockScreen } = useScreenLock(); // Use screen lock context
  const [credentials, setCredentials] = useState({
    username: '',
    password: '',
    db: '',
    baseDb: '',
  });
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const apiService = new ApiService();

  // useEffect(() => {
  //   const url = window.location.href;
  //   const regex = /_username=([^&]+)&_password=([^&]+)&_db=([^&]+)&_baseDb=([^&]+)/;
  //   const match = url?.match(regex);
  //   if (match) {
  //     if (localStorage.getItem('Token')) {
  //       return;
  //     }
  //     handleLogin({
  //       username: match[1],
  //       password: match[2],
  //       db: match[3],
  //       baseDb: match[4],
  //     });
  //   } else if (localStorage.getItem('Token')) {
  //     return;
  //   } else {
  //     handleOut();
  //     return;
  //   }
  // }, []);

  // const handleLogin = async (first) => {
  //   let body = {
  //     email: credentials?.username || first?.username,
  //     password: credentials?.password || first?.password,
  //     basedb: credentials?.baseDb || first?.baseDb,
  //     supportdb: credentials?.db || first?.db,
  //   };
  //   try {
  //     const response = await apiService.post('GET_ENCRYPT_TOKEN', body);

  //     if (response && response.status === 200) {
  //       localStorage.setItem('Token', response?.data?.data?.accessToken);
  //       dispatch(saveLogin(response?.data));

  //       const userId = await userManagement.getUserId(response?.data?.data?.userCompanies);
  //       const InvUserId = userManagement?.getUserId2(response?.data?.data?.accessToken);
  //       if (userId) {
  //         invokeLogin(userId);
  //       }
  //       const userRole = userManagement.getUserRole(response?.data?.data?.accessToken);
  //       dispatch(setUserRole(userRole));
  //       localStorage.setItem('Refresh_Token', response?.data?.data?.refreshToken);
  //       navigate('/');
  //     } else if (response.status == false) {
  //       localStorage.clear();
  //       window.location.href = 'https://app.pro360erp.com/';
  //     }
  //   } catch (error) {
  //     console.log(error, 'error');
  //     toast.error(error.response.data.data);
  //   }
  // };

  useEffect(() => {
    document.body.classList.toggle('dark-theme', theme === 'dark');
  }, [theme]);

  useEffect(() => {
    if (theme === 'dark') {
      document.body.classList.add('dark-theme');
    } else {
      document.body.classList.remove('dark-theme');
    }
    console.log('Body class list:', document.body.classList);
  }, [theme]);

  useEffect(() => {
    const menuRegex = /^\/Cashier\/orderDetails\/[^\/]+$/;
    const { pathname } = location;
    if (pathname === '/Cashier/OpenCashList') {
      setHeaderText('Cash Opening');
    } else if (pathname === '/Cashier/ShiftOpen') {
      setHeaderText('Opening Cash');
    } else if (pathname === '/Cashier/handOverForm') {
      setHeaderText('Cash Hand Over');
    } else if (pathname === '/Cashier/DayOpen') {
      setHeaderText('Opening Cash');
    } else if (pathname === '/Cashier/DayClose') {
      setHeaderText('Day Closing Cash');
    } else if (pathname === '/Cashier/DayOpening') {
      setHeaderText('Day Opening');
    } else if (pathname === '/Cashier/WaiterOrders') {
      setHeaderText('Table Orders');
    } else if (pathname === '/Cashier/SaleHistory') {
      setHeaderText('Complete Orders');
    } else if (pathname === '/Cashier/HoldOrders') {
      setHeaderText('Hold Orders');
    } else if (pathname === '/Cashier/Dispute') {
      setHeaderText('Dispute');
    } else if (pathname === '/Cashier/CounterSelection') {
      setHeaderText('Counter Selection');
    } else if (pathname === '/Cashier/PayOut') {
      setHeaderText('Pay-Out');
    } else if (pathname === '/Cashier/PayIn') {
      setHeaderText('Pay-In');
    } else if (pathname === '/Cashier/HandOvered') {
      setHeaderText('HandOver');
    } else if (pathname === '/Cashier/ordersD&D') {
      setHeaderText('Update Status');
    } else if (pathname === '/cashier/Tables') {
      setHeaderText('Table Booking');
    } else if (pathname === '/Cashier/UpdateOrder') {
      setHeaderText('Edit Order');
    } else if (pathname === '/Cashier/SwitchUser') {
      setHeaderText('Switch User');
    } else if (pathname === '/Cashier/PayInForm') {
      setHeaderText('Create Pay In ');
    } else if (pathname === '/Cashier/PayOutForm') {
      setHeaderText('Create Pay Out ');
    } else if (menuRegex.test(pathname)) {
      setHeaderText('Order Details');
    } else if (pathname === '/Cashier/Deliveries') {
      setHeaderText(' Delivery Que List');
    } else if (pathname === '/Cashier/Delivery/List') {
      setHeaderText(' Delivered Orders');
    } else {
      setHeaderText('Place Order');
    }
  }, [location]);

  const handleOut = () => {
    dispatch(logout());
    localStorage.clear();
    console.log('clicked');
    dispatch(clearCart());
    dispatch(clearComboCart());
    dispatch(clearTable());
    window.location.href = 'https://app.pro360erp.com';
    window.location.reload(false);
  };

  // Handle screen lock/unlock
  const handleLockToggle = () => {
    if (isLocked) {
      // If locked, the unlock will be handled by the overlay component
      return;
    } else {
      lockScreen();
      toast.info('System locked successfully');
    }
  };
  const token = async () => {
    return localStorage.getItem('Token');
  };
  // const CashierName =
  //   userManagement.getUserName(token).userName?.length > 20
  //     ? userManagement.getUserName(token).userName.substring(0, 10) + '...'
  //     : userManagement.getUserName(token).userName;
  const CashierName = (() => {
    // First try Redux userName
    if (userName) {
      return userName.length > 20 ? userName.substring(0, 10) + '...' : userName;
    }

    // Fallback to extracting from token
    if (token) {
      const extractedName = userManagement.getUserName(token);
      const name = extractedName?.userName || extractedName;
      return name && name.length > 20 ? name.substring(0, 10) + '...' : name || 'User';
    }

    return 'User';
  })();
  return (
    <nav className="navbar-expand-lg mainBG">
      <div className="container-fluid">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse d-flex justify-content-between" id="navbarSupportedContent">
          <div className="dnon">
            <div className="Headtxt">{headerText}</div>
            <div className="headtxt2"></div>
          </div>
          <div className="d-flex gap-2 pad">
            <div className="gap-3 d-flex">
              {/* Theme toggle */}
              <div className="iconBG" onClick={() => dispatch(toggleTheme())} title="Toggle Theme">
                <FiSunrise />
              </div>

              {/* Lock/Unlock button */}
              <div
                className="iconBG"
                onClick={handleLockToggle}
                title={isLocked ? 'System Locked' : 'Lock System'}
                style={{
                  backgroundColor: isLocked ? '#dc3545' : undefined,
                  color: isLocked ? 'white' : undefined,
                }}
              >
                {isLocked ? <FiLock /> : <FiUnlock />}
              </div>
            </div>

            <div className="profilebox dropdown">
              {CashierName}
              {location.pathname !== '/Cashier/ShiftOpen' && (
                <div className="dropdown-content-stats pt-1">
                  <Link to="/Cashier/handOverForm" className="p-2">
                    Shift Close
                  </Link>
                  <Link to="/Cashier/SwitchUser" className="p-2">
                    Switch User
                  </Link>
                  <Link to="/Cashier/DayClose" className="p-2">
                    Day Close
                  </Link>
                  <Link onClick={() => handleOut()} className="p-2">
                    logOut
                  </Link>
                </div>
              )}
            </div>

            <div className="adminprofileimgbox boxicon">
              <FiLogOut className="" size={25} />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default CashierHeader;
